import { Router } from '@angular/router'
import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { ApiService } from './api.service'
import { Claim } from 'app/interfaces/claim.interface'
import { ClaimActions } from 'app/interfaces/claim-actions'

@Injectable({
    providedIn: 'root',
})
export class ClaimService {
    constructor(private api: ApiService, private router: Router,private translate: TranslateService) {}
    
    private translations(){
        this.translate.get([
            'global.complete',
            'my_claims.draft_title',
            'global.view_detail',
            'my_claims.pending_approval_description',
            'my_claims.in_review_title',
            'my_claims.in_review_subtitle',
            'my_claims.in_review_description',
            'my_claims.closed_title',
            'my_claims.closed_subtitle',
            'my_claims.closed_description',
            'my_claims.denied_title',
            'my_claims.denied_subtitle',
            'my_claims.denied_description',
            'my_claims.approved_title',
            'my_claims.approved_subtitle',
            'my_claims.approved_description'
        ])
    }
 
    getClaimActions(claim: Claim): ClaimActions {
        return {
            DRAFT: {
                actionMessage: 'global.complete',
                title: 'my_claims.draft_title',
                subtitle: null,
                description: null,
                waitActionMessage: null,
                actionFunction: () => {
                    this.router.navigate(['create-claim', claim.id])
                    //GO TO claim creation
                },
                iconBadgeClass: 'claim draft',
                scoreBoxClass: 'warning'
            },
            IN_REVIEW: {
                actionMessage: 'global.view_detail', //add more documents when is pending information?
                title: claim.statusi18nkey == 'my_claims.pending_approval' ? 
                'my_claims.pending_approval' : claim.statusi18nkey == 'my_claims.pending_information' ? 'my_claims.in_review_title': '',
                subtitle: claim.statusi18nkey == 'my_claims.pending_information' ? 'my_claims.in_review_subtitle': null ,
                description: claim.statusi18nkey == 'my_claims.pending_approval' ? 
                'my_claims.pending_approval_description': 
                claim.statusi18nkey == 'my_claims.pending_information' ? 'my_claims.in_review_description' : '',
                waitActionMessage: null,
                actionFunction: () => {
                    this.router.navigate(['/claim-detail/', claim.id]) //add more documents when is pending information?
                },
                iconBadgeClass: 'claim review',
                scoreBoxClass: 'warning'
            },
            CLOSED: {
                actionMessage: 'global.view_detail',
                title: 'my_claims.closed_title',
                subtitle: 'my_claims.closed_subtitle',
                description: 'my_claims.closed_description',
                waitActionMessage: null,
                actionFunction: () => {
                    this.router.navigate(['/claim-detail/', claim.id])
                },
                iconBadgeClass: 'claim draft',
                scoreBoxClass: 'gray'
            },
            DENIED: {
                actionMessage: 'global.view_detail',
                title: 'my_claims.denied_title',
                subtitle: 'my_claims.denied_subtitle',
                description: 'my_claims.denied_description',
                waitActionMessage: null,
                actionFunction: () => {
                    this.router.navigate(['/claim-detail/', claim.id])
                },
                iconBadgeClass: 'claim rejected',
                scoreBoxClass: 'error'
            },
            APPROVED: {
                actionMessage: 'global.view_detail',
                title: 'my_claims.approved_title',
                subtitle: 'my_claims.approved_subtitle',
                description: 'my_claims.approved_description',
                waitActionMessage: null,
                actionFunction: () => {
                    this.router.navigate(['/claim-detail/', claim.id])
                },
                iconBadgeClass: 'claim info',
                scoreBoxClass: 'info'
            },
        }
    }
}
